import React from "react";
import { BlogLayout } from "../../containers";
import { Contact } from "../../components";
function Cotact() {
  return (
    <BlogLayout>
      <Contact />
    </BlogLayout>
  );
}

export default Cotact;
